// all constants for the web app
interface RefTimezones {
  [key: string]: string;
}

const constants = {
  roleTag: {
    companyAdmin: 1,
    custom: 2,
    messaging: 3,
    reporting: 4,
    standard: 5,
    superAdmin: 6,
  },
  appVersion: '1.0.0',
  unicode: {
    bull: '\u2022',
    dash: '\u2014',
    space: '\u00A0',
  },
  localStorageKey: {
    tokens: 'Tokens'
  },
  otpTimeOut: 120,
  gstAmount: 11,
  orderPrepTime: 5,
  breakfastTime: '10:30 am',
  defaultLocation: {
    latitude: -37.8138737,
    longitude: 144.9634605,
  },
  maxPaymentMethods: 3,
  userPointsMethodId: '00000000-AAAA-0000-0000-000000000000',
  secureStore: {
    preferences: {
      theme: 'secureStorePreferencesTheme',
    },
    loggedIn: {
      user: 'secureStoreLoggedInUser',
      userToken: 'secureStoreLoggedInUserToken',
      refreshToken: 'secureStoreLoggedInUserRefreshToken',
      userCustomer: 'secureStoreLoggedInUserCustomer',
    },
    device: {
      id: 'secureStoreDeviceId',
      fcmToken: 'secureStoreDeviceToken',
    },
    remindLaterDate: 'secureStoreRemindLaterDate',
    selectedSite: 'selectedSite',
    selectedOrdrMode: 'selectedOrdrMode',
    userDialogShown: 'userDialogShown',
  },
  defaultTimeZone: 'Australia/Sydney',
  defaultErrorMessage:
    'Sorry, something went wrong. Please refresh the page or log back in.',
  mimeTypes: {
    pdf: 'application/pdf',
    jpeg: 'image/jpeg',
    xlsx: 'application/excel',
    csv: 'text/csv',
  },
  refComboSizes: ['Small', 'Medium', 'Large'],
  refCategorySizes: ['small', 'medium', 'large'],
  //refComboSizeCodes: ['S', 'M', 'L'],
  refComboSizeCodes: { 0: 'S', 1: 'M', 2: 'L' },
  refTimezones: {
    WA: 'Australia/Perth',
    SA: 'Australia/Adelaide',
    NT: 'Australia/Darwin',
    QLD: 'Australia/Brisbane',
    NSW: 'Australia/Sydney',
    VIC: 'Australia/Melbourne',
    TAS: 'Australia/Hobart',
    ACT: 'Australia/Sydney',
  },
  dateFormat: 'dd/MM/yyyy',
  appName: 'App CMS',
  no_image: 'https://stprod0001ts.blob.core.windows.net/cjsales/no-image.jpg',
  comboSizes: [0, 1, 2],
  daysInWeek: [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ],
  orderMode: {
    walkIn: 'WalkIn',
    eatIn: 'EatIn',
    driveThru: 'DriveThru',
    delivery: 'Delivery',
  },
  orderModeDisplay: {
    WalkIn: 'Take Away',
    EatIn: 'Dine In',
    DriveThru: 'Drive Thru',
    Delivery: 'Delivery',
  },
  refGender: [
    { id: 0, label: 'Male', value: 'M' },
    { id: 1, label: 'Female', value: 'F' },
    { id: 2, label: 'Other', value: 'O' },
    { id: 3, label: 'Unspecified', value: 'U' },
  ],
  refFAQs: [
    {
      question: 'How do I use my Happy Star Points?',
      answer:
        'You can use your Happy Star Points to pay for your entire order when purchasing through the app. If you have enough points to cover the total cost, you’ll be prompted to pay with them on the order confirmation page.',
    },
    {
      question:
        'Can I use my Happy Star Points to cover just one item in my cart?',
      answer:
        'No, Happy Star Points can only be used to cover the full cost of an order, not individual items.',
    },
    {
      question: 'How do I earn Happy Star Points?',
      answer:
        'To earn points, sign up for Carl’s Club and place orders through the MyCarl’s App. You can earn points on takeaway, dine-in, drive-through, and delivery (available only via the app).',
    },
    {
      question: 'How many Happy Star Points do I need to redeem a free item?',
      answer:
        'The number of points required to cover an order depends on the restaurant you’re ordering from.',
    },
  ],
};
export default constants;
